import { makeStyles } from "@material-ui/core";


export const searchInputStyles = makeStyles((theme) => ({
    root: {
        padding: "3px 0px",
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
    input: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    chip: {
        marginRight: theme.spacing(1),
    },
}));
